/**
 * Created by Claude on 08.03.2026
 */

const IslandPreviewWindow = Prefab.createWindow(
    "island_decoration_preview_window",
    "island_preview_window_prefab_json",
    {
        bundles: (mission) => [`island_decoration_items_${mission.logic.period}`]
    }
);
